import script from "./MainIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MainIndex.vue?vue&type=script&setup=true&lang=js"

import "./MainIndex.vue?vue&type=style&index=0&id=c4f6deb8&lang=css"
import "./MainIndex.vue?vue&type=style&index=1&id=c4f6deb8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4f6deb8"]])

export default __exports__